import ServicePageTemplate from '../services/ServicePageTemplate';
import { servicePageData } from '../../mocks/servicePages';
const PlumbingPage = () => <ServicePageTemplate data={servicePageData['plumbing']} />;
export default PlumbingPage;
